"use client";

import { FormEvent, useState, useTransition } from "react";
import { useRouter } from "next/navigation";
import { updatePenName } from "@/lib/actions/profile-actions";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { notifyProfileNameChanged } from "@/lib/profile/client-events";
interface PenNamePromptProps {
  initialPenName: string;
  onSaved?: () => void;
}
export function PenNamePrompt({
  initialPenName,
  onSaved
}: PenNamePromptProps) {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(true);
  const [penName, setPenName] = useState(initialPenName);
  const [error, setError] = useState<string | null>(null);
  const [isPending, startTransition] = useTransition();
  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);
    startTransition(async () => {
      try {
        const result = await updatePenName(penName);
        if ("error" in result) {
          setError(result.error);
          return;
        }
        notifyProfileNameChanged(result.userId, result.penName);
        onSaved?.();
        setIsOpen(false);
        router.refresh();
      } catch {
        setError("We couldn't save your pen name. Please try again.");
      }
    });
  }
  return <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogContent className="sm:max-w-md">
                <form onSubmit={handleSubmit} className="space-y-5">
                    <DialogHeader>
                        <DialogTitle>Choose your pen name</DialogTitle>
                        <DialogDescription>
                            Google shared this name with Iloris. Confirm it or choose the
                            public name other readers and authors should see.
                        </DialogDescription>
                    </DialogHeader>

                    <div className="space-y-2">
                        <Label htmlFor="pen-name">Pen name</Label>
                        <Input id="pen-name" value={penName} onChange={event_0 => setPenName(event_0.target.value)} maxLength={50} autoComplete="nickname" autoFocus required />
                        {error && <p role="alert" className="text-sm text-destructive">
                                {error}
                            </p>}
                    </div>

                    <DialogFooter>
                        <Button type="button" variant="ghost" onClick={() => setIsOpen(false)} disabled={isPending}>
                            Not now
                        </Button>
                        <Button type="submit" disabled={isPending}>
                            {isPending ? "Saving..." : "Save pen name"}
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>;
}